<div class="preview">
  <div class="preview-header">
    <span class="preview-titulo notif-heading">Vista previa</span>
    <div class="preview-tabs">
      <button type="button" class="preview-tab" [class.active]="tab() === 'push'" (click)="cambiarTab('push')">Push</button>
      <button type="button" class="preview-tab" [class.active]="tab() === 'popup'" (click)="cambiarTab('popup')">Pop-up</button>
    </div>
  </div>

  <div class="phone-frame">
    <div class="phone-statusbar"><span>11:26</span><span>80%</span></div>
    <div class="phone-screen" [class.phone-screen-push]="tab() === 'push'" [class.phone-screen-popup]="tab() === 'popup'">
      @if (mostrarDestino()) {
        <div class="destino-sim">
          <div class="destino-sim-header">
            <button type="button" class="destino-sim-volver" (click)="destinoAbierto.set(false)">← Volver</button>
            <span class="destino-sim-nombre">{{ tipoEnlace() === 'EXTERNO' ? 'Navegador' : nombreSeccion() }}</span>
          </div>
          @if (tipoEnlace() === 'EXTERNO') {
            <div class="destino-sim-url">{{ urlDestino() }}</div>
            <div class="destino-sim-contenido">Simulación: se abriría esta página en el navegador.</div>
          } @else {
            <div class="destino-sim-contenido">Simulación: se abriría la sección «{{ nombreSeccion() }}» de la app.</div>
          }
        </div>
      } @else if (tab() === 'push') {
        <div class="push-card" [class.push-card-vacio]="esVacioCorto()">
          <span class="push-card-icon">G</span>
          <div class="push-card-body">
            <div class="push-card-meta">
              <span class="push-card-app">GEA Móvil</span>
              <span class="push-card-time">ahora</span>
            </div>
            <div class="push-card-title" [class.push-card-title-vacio]="esVacioTitulo()">{{ textoTitulo() }}</div>
            <div class="push-card-text">{{ textoCorto() }}</div>
          </div>
        </div>
      } @else {
        <div class="popup-backdrop" aria-hidden="true">
          <div class="popup-backdrop-header">
            <span>☰</span>
            <span class="popup-backdrop-brand">GEA</span>
            <span>🔔</span>
          </div>
          <div class="popup-backdrop-greeting">Hola, <em>(NOMBRE)</em></div>
        </div>

        <div class="popup-notif-card" [class.popup-notif-vacio]="esVacioAmpliado()">
          <div class="popup-notif-chip">
            <span class="popup-notif-icon">GEA</span>
            <span class="popup-notif-label">Nueva notificación</span>
            <span class="popup-notif-cerrar" aria-hidden="true">×</span>
          </div>
          <div class="popup-notif-body">
            <div class="popup-notif-title" [class.popup-notif-title-vacio]="esVacioTitulo()">{{ textoTitulo() }}</div>
            <div class="popup-notif-text">{{ textoAmpliado() }}</div>
            @if (textoBotonEnlace() !== null) {
              <button type="button" class="popup-notif-boton" (click)="abrirDestino()">
                {{ textoBoton() }} <span aria-hidden="true">{{ iconoBoton() }}</span>
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <div class="preview-hint">La vista se actualiza a medida que completás los campos.</div>
</div>
